import { render, staticRenderFns } from "./TaskToDo.vue?vue&type=template&id=1e2b346f&"
import script from "./TaskToDo.vue?vue&type=script&lang=js&"
export * from "./TaskToDo.vue?vue&type=script&lang=js&"
import style0 from "./TaskToDo.vue?vue&type=style&index=0&id=1e2b346f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports